import { qportalApi } from './qportal-api';
const userVerify = async (userVerify) => {
    return qportalApi.post('shuffti-pro/verify', userVerify);
};
const getStatus = async (reference) => {
    return qportalApi.post('shuffti-pro/status', reference);
};
const ShufftiProApi = {
    userVerify,
    getStatus
};
export default ShufftiProApi;
